import { render, staticRenderFns } from "./SmQuestion.vue?vue&type=template&id=709ff951&"
import script from "./SmQuestion.vue?vue&type=script&lang=ts&"
export * from "./SmQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports